/**
 * D6ForceGTConditionType - Condition qui vérifie si la Force est supérieure à une valeur
 * Identique à Java ForceGTCondition
 */

import {ConditionType} from '../../types/ConditionType';
import {GameState} from '../../../models/GameState';
import GameStateHelper from '../../../helpers/GameStateHelper';

export class D6ForceGTConditionType implements ConditionType {
  typeName = 'D6_COND_FORCE_GT';
  messageKey = 'laventurier.condition.d6.force-gt.name';
  descriptionKey = 'laventurier.condition.d6.force-gt.desc';
  errorKey = 'laventurier.condition.d6.force-gt.error';
  hasValue = true;
  hasAttribute = false;

  evaluate(gameState: GameState, condition: any): boolean {
    const threshold = parseInt(condition.value || condition.threshold || '0', 10);
    if (isNaN(threshold)) {
      console.log('[D6ForceGTConditionType] FALSE: invalid threshold value');
      return false;
    }

    const forceField = GameStateHelper.getAdventureExtraField(gameState, 'D6_FORCE');
    if (!forceField) {
      console.log('[D6ForceGTConditionType] FALSE: D6_FORCE field not found');
      return false;
    }

    const currentForce = parseInt(String(forceField.currentValue || forceField.initValue || '0'), 10);
    const result = currentForce > threshold;
    console.log(`[D6ForceGTConditionType] ${result ? 'TRUE' : 'FALSE'}: currentForce=${currentForce}, threshold=${threshold}`);
    return result;
  }
}
